import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";

const ScheduleGrid = urlConfig.ScheduleGrid;
const GetPerformanceReport = urlConfig.GetPerformanceReport;
const ScheduleEdit= urlConfig.ScheduleEdit;
const GetExcel= urlConfig.getexcel;

export const getReports = async (params: any) => {
  try {
    const response = await postCall(ScheduleGrid, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getPerformanceReports = async (params: any) => {
  try {
    const response = await postCall(GetPerformanceReport, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const editReport = async (params: any) => {
  try {
    const response = await postCall(ScheduleEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getExcelReport = async (params: any) => {
    try {
        const response = await postFileDownloadCall(GetExcel, params);
        return response.data;
    } catch (error) {
        console.log("Error in DownloadEmailTemplate ", error);
        throw error;
    }
};

export const performanceReportAddEdit = async (params: any) => {
  try {
    const response = await postCall(urlConfig.PerformanceReportAddEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};